module.exports = __webpack_public_path__ + "img/qrcode.5d4d8550.png";